export const INITIAL_VALUE = 'row';

export function constructSnippet(
  flexDirection:
    | 'row'
    | 'row-reverse'
    | 'column'
    | 'column-reverse' = INITIAL_VALUE
) {
  return `\
.container {
  display: flex;
  flex-direction: ${flexDirection};
  justify-content: center;
  align-items: center;
  gap: 4px;
}`;
}
